import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { Box, Typography } from '@mui/material';
import { close_message_action } from '../../redux/action';
import { MessageBox } from 'shared/components/dialogs/message-box';
export function MessageComponent() {
    // Импорт состояний
    const { open, open_message } = useAppSelector((state) => state.upgrade_soft);
    const handlerClose = useAction(close_message_action);
    return (_jsx(MessageBox, { open: open_message.show && open, onClose: handlerClose, title: open_message.title, isError: true, closeButtonTitle: "\u041E\u041A", children: _jsx(Box, { children: _jsx(Typography, { variant: "subtitle1", children: open_message.message }) }) }));
}
